import type { ReactElement } from "react"

import type { MapSearchResult, Project } from "../../../redux"
import { SearchResultViewer } from "../../organisms"

export interface ISearchMapSelectorProps {
  projectSelection: Project[]
  onMapSelect: (map: Project) => void
  onShowPreview?: (map: Project) => void
  onNavigateToIndex: () => void
}

export function SearchMapSelector(props: ISearchMapSelectorProps): ReactElement {
  const { projectSelection, onMapSelect, onShowPreview, onNavigateToIndex } = props

  function toProject(map: MapSearchResult): Project {
    return {
      metaDataId: map.id,
      drawings: [],
      attachments: [],
      bundles: []
    }
  }

  function onMapSelected(map: MapSearchResult): void {
    onMapSelect(toProject(map))
  }

  function onMapPreview(map: MapSearchResult): void {
    if (onShowPreview) onShowPreview(toProject(map))
  }

  return (
    <SearchResultViewer
      projectSelection={projectSelection}
      onMapClicked={onMapSelected}
      onMapPreview={onMapPreview}
      onNavigateToIndex={onNavigateToIndex}
    />
  )
}
